module.exports = __webpack_public_path__ + "img/gift-04-c4.374a674c.png";